import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Microscope, Wheat, Fish, Share2 } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Crop Breeding',
  description: 'Developing high-yielding, disease-resistant, and climate-smart crop varieties.',
  icon: Wheat
}, {
  title: 'Livestock Research',
  description: 'Improving animal breeds, nutrition, and disease management.',
  icon: Microscope
}, {
  title: 'Fisheries Research',
  description: 'Advancing aquaculture technologies and sustainable fisheries management.',
  icon: Fish
}, {
  title: 'Technology Dissemination',
  description: 'Sharing research findings and innovations with extension workers and farmers.',
  icon: Share2
}];
export function NaroPage() {
  return <>
      <Header data-id="element-1217" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1218">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1219">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=1600&h=600&fit=crop")'
        }} data-id="element-1220"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1221"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1222">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1223">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1224">
                <Home className="w-4 h-4 mr-1" data-id="element-1225" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1226" />
              <span data-id="element-1227">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1228" />
              <span className="text-white font-medium" data-id="element-1229">NARO</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1230">NARO</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1231">
              National Agricultural Research Organisation.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-1232">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-1233">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1234">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1235">
              To coordinate, oversee, and guide agricultural research in Uganda
              to ensure the generation and dissemination of appropriate, safe,
              and cost-effective technologies. NARO operates 16 public
              agricultural research institutes across the country.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-1236">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1237">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1238">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-1239">
                    <Icon className="w-6 h-6" data-id="element-1240" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-1241">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1242">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-1243" />
    </>;
}